import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { deleteSubCategory, getAllSubCategories, createSubCategory, editSubCategory, getOneSubCategory } from '../../api/axiosSubCategories';
import { getAllBroadCategories } from '../../api/axiosBroadCategories';
import { getAllCategories, getBroadCategoryCategories } from '../../api/axiosCategories';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dialog } from 'primereact/dialog';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import TableActions from '../../components/buttonActions/TableActions';









const SubSubCategories = () => {
  const { broadCategories, setBroadCategories,categories,setCategories,subCategories, setSubCategories, fetcherror,setFetcherror,isLoading, setIsLoading} = useContext(DataContext);
 
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()

  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Editing
  const [selectedBroadCategory, setSelectedBroadCategory] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  
  const [subCategory, setSubCategory] = useState("");
  const [selectionCategories, setSelectionCategories] = useState([]);
  const [editedSubCategory, setEditedSubCategory] = useState("");
  


 

  const NewTitle = "All SubCategories";
  useEffect(() => {
    
    getAllSubCategories(setSubCategories, setFetcherror,setIsLoading);
    getAllCategories(setCategories, setFetcherror);
    getAllBroadCategories(setBroadCategories, setFetcherror);
    
  }, []);


  // Create New Array of SubCategories with BroadCategories and Categories.
  const newsubcategoriesArray = subCategories.map((item) => {
    const newscategoriesArray = categories.map((itemc) => {
      const resulta = broadCategories.find((itemb) => itemb.id === itemc.broadcategory_id);
      return { ...itemc, broadcategory: resulta ? resulta.name : null };
    });
    const result = newscategoriesArray.find((itemd) => itemd.id === item.category_id);
    return { ...item,category: result ? result.name : null, broadcategory_id:result ? result.broadcategory_id : null, broadcategory:result ? result.broadcategory : null };
  });
  

  // console.log(newsubcategoriesArray, "newsubcategoriesArray");
  
  const filteredSubCategories = newsubcategoriesArray.filter((item) => item.name.toLowerCase().includes(globalFilter) || item.broadcategory.toLowerCase().includes(globalFilter) || item.category.toLowerCase().includes(globalFilter))
  const filteredReversedSubCategories = filteredSubCategories.reverse();
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid, setSubCategories, setFetcherror, handleAllToasts) => {
    return () => {
      deleteSubCategory(pkid, setSubCategories, setFetcherror, handleAllToasts);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this SubCategory?, Click "Yes" to Proceed or "No" to Cancel</p>
  );

  const getItemtoEdit = (pkid, items) => {
    const foundItem = items.find((item) => item.id === pkid);
    setEditedSubCategory(foundItem?.name);
   
  }



  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
           
          <SearchToolBar
                    setAddItemDialogVisible={setAddItemDialogVisible}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                    searchPlaceholder="SubCategories"
                    createLabel="SubCategory"
            />
          
        <DataTable
          value={filteredSubCategories}
          showGridlines
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 20]}
          emptyMessage={isLoading ? "Fetching Data": "No categories found"}
        >
                    <Column header="S/N" body={(rowData) => newsubcategoriesArray.indexOf(rowData)+1 } sortable> </Column>
                    <Column header="BroadCategory" body={(rowData) => rowData.broadcategory } sortable></Column>
                    <Column header="Category" body={(rowData) => rowData.category } sortable></Column>
                    <Column header="SubCategory"   body={(rowData) => rowData.name} sortable></Column>
                    <Column header="Actions" body={(rowData) => (  
                            <TableActions
                              id={rowData.id}
                              data={subCategories}
                              getItemtoEdit={getItemtoEdit}
                              setSelectedId={setSelectedId}
                              setEditDialogVisible={setEditDialogVisible}
                              setDeleteDialogVisible={ setDeleteDialogVisible}
                            />
                        
                          )}>
                    </Column>
        </DataTable>

        
        {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="New SubCategory" visible={addItemeDialogVisible} style={{ width: '25vw' }} onHide={() => setAddItemDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                createSubCategory(subCategory,setSubCategory, setFetcherror, handleAllToasts, selectedCategory?.id,setSubCategories,setIsLoading);
                if (subCategory ) { setAddItemDialogVisible(false); }
              }}>
                   <label htmlFor="phoneReporter" className="block text-900 font-medium mb-2">Broad Category </label>
                  <Dropdown
                  value={selectedBroadCategory} onChange={(e) => {
                    setSelectedBroadCategory(e.value);
                    getBroadCategoryCategories(setSelectionCategories, setFetcherror, e.value?.id);
                  }}
                   options={broadCategories} optionLabel="name"
                  placeholder="-- Select BroadSubCategory --" showClear className="w-full mb-4"
                />
                
                <label htmlFor="category" className="block text-900 font-medium mb-2">Category</label>
                <Dropdown value={selectedCategory} onChange={(e) => setSelectedCategory(e.value)}
                options={selectionCategories} optionLabel="name"
                placeholder="-- Select Category --" showClear className="w-full mb-4" />
                

                <label htmlFor="phoneReporter" className="block text-900 font-medium mb-2">SubCategory </label>
                <InputText
                  className='w-full mb-4'
                  type="text"
                  placeholder="Enter SubCategory Name"
                  value={subCategory}
                  onChange={(e) => setSubCategory(e.target.value)}
                />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setSubCategory("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }
        


        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="Edit SubCategory" visible={editDialogVisible} style={{ width: '25vw' }} onHide={() => setEditDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                editSubCategory( selectedId, editedSubCategory, setEditedSubCategory,  setFetcherror, handleAllToasts, setSubCategories,setIsLoading);
                if (editedSubCategory) { setEditDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    // disabled
                    placeholder="Enter SubCategory Name"
                    value={editedSubCategory}
                    onChange={(e) => setEditedSubCategory(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false); setSubCategory("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }

        
        
        {
                deleteDialogVisible &&
        
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setSubCategories, setFetcherror, handleAllToasts)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
       
                
      </Card>
      
    </div>
  )
}

export default SubSubCategories


